// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Alert = require("../common/Components/Alert.bs.js");
let React = require("react");
let ButtonsV5 = require("../common/Components/ButtonsV5.bs.js");
let FeaturesV3 = require("../../reason/featureFlipper/FeaturesV3.bs.js");
let ConfirmDialog = require("../common/Components/ConfirmDialog.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let AccountMemberUtils = require("./AccountMemberUtils.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
let SubuserPendingInvitations_account_graphql = require("../../__generated__/SubuserPendingInvitations_account_graphql.bs.js");
let SubuserPendingInvitationsRevokeMutation_graphql = require("../../__generated__/SubuserPendingInvitationsRevokeMutation_graphql.bs.js");

let convertFragment = SubuserPendingInvitations_account_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, SubuserPendingInvitations_account_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(SubuserPendingInvitations_account_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, SubuserPendingInvitations_account_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(SubuserPendingInvitations_account_graphql.node, convertFragment, fRef);
}

let Fragment_accountMemberRole_decode = SubuserPendingInvitations_account_graphql.Utils.accountMemberRole_decode;

let Fragment_accountMemberRole_fromString = SubuserPendingInvitations_account_graphql.Utils.accountMemberRole_fromString;

let Fragment = {
  accountMemberRole_decode: Fragment_accountMemberRole_decode,
  accountMemberRole_fromString: Fragment_accountMemberRole_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

let convertVariables = SubuserPendingInvitationsRevokeMutation_graphql.Internal.convertVariables;

let convertResponse = SubuserPendingInvitationsRevokeMutation_graphql.Internal.convertResponse;

let convertWrapRawResponse = SubuserPendingInvitationsRevokeMutation_graphql.Internal.convertWrapRawResponse;

let commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, SubuserPendingInvitationsRevokeMutation_graphql.node, convertResponse, convertWrapRawResponse);

let use$1 = RescriptRelay_Mutation.useMutation(convertVariables, SubuserPendingInvitationsRevokeMutation_graphql.node, convertResponse, convertWrapRawResponse);

let RevokeMutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use$1
};

function SubuserPendingInvitations(props) {
  let currentUserRole = props.currentUserRole;
  let data = RescriptRelay_Fragment.useFragment(SubuserPendingInvitations_account_graphql.node, convertFragment, props.account);
  let match = use$1();
  let revoking = match[1];
  let revoke = match[0];
  let match$1 = React.useState(() => {});
  let setError = match$1[1];
  let error = match$1[0];
  let match$2 = React.useState(() => {});
  let setSelected = match$2[1];
  let selected = match$2[0];
  let match$3 = FeaturesV3.useIsSubuserInvitationsEnabled();
  if (match$3 !== undefined && match$3 && currentUserRole === "OWNER") {
    return JsxRuntime.jsxs(JsxRuntime.Fragment, {
      children: [
        error !== undefined ? JsxRuntime.jsx("tr", {
            children: JsxRuntime.jsx("td", {
              children: JsxRuntime.jsx(Alert.$$Error.make, {
                title: error
              }),
              className: "py-3",
              colSpan: 5
            })
          }) : null,
        data.pendingSubuserInvitations.map(invitation => JsxRuntime.jsxs("tr", {
          children: [
            JsxRuntime.jsx("td", {
              children: invitation.firstName + " " + invitation.lastName,
              className: "block py-1 pr-4 font-semibold break-words md:table-cell md:py-4"
            }),
            JsxRuntime.jsx("td", {
              children: invitation.email,
              className: "block py-1 pr-4 text-zinc-600 break-words md:table-cell md:py-4"
            }),
            JsxRuntime.jsx("td", {
              children: AccountMemberUtils.roleOutputToString(invitation.role),
              className: "block py-1 pr-4 text-zinc-600 md:table-cell md:py-4"
            }),
            JsxRuntime.jsx("td", {
              children: "Invited",
              className: "block py-1 pr-4 text-sm text-zinc-600 md:table-cell md:py-4"
            }),
            JsxRuntime.jsx("td", {
              children: JsxRuntime.jsx("div", {
                children: JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
                  onClick: param => setSelected(param => invitation.id),
                  disabled: revoking,
                  children: "Revoke"
                }),
                className: "flex md:justify-end"
              }),
              className: "block pt-2 md:table-cell md:py-4"
            })
          ],
          className: "block py-4 md:table-row md:py-0"
        }, invitation.id)),
        JsxRuntime.jsx(ConfirmDialog.make, {
          title: "Revoke invitation?",
          ariaLabel: "Revoke invitation",
          body: "This invitation will stop working and its seat will become available.",
          isOpen: Stdlib_Option.isSome(selected),
          onCancel: () => setSelected(param => {}),
          cancelButton: JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
            onClick: param => setSelected(param => {}),
            disabled: revoking,
            children: "Cancel"
          }),
          confirmButton: JsxRuntime.jsx(ButtonsV5.DangerButton.make, {
            onClick: param => {
              if (selected !== undefined) {
                setError(param => {});
                revoke({
                  id: selected
                }, undefined, undefined, undefined, (param, param$1) => {
                  let revokeSubuserInvitation = param.revokeSubuserInvitation;
                  switch (revokeSubuserInvitation.__typename) {
                    case "SubuserInvitationFailed" :
                      let message = revokeSubuserInvitation.message;
                      return setError(param => message);
                    case "SubuserInvitationRevoked" :
                      return setSelected(param => {});
                    case "__unselected" :
                      return setError(param => "The invitation could not be revoked. Please try again.");
                  }
                }, param => setError(param => "The invitation could not be revoked. Please try again."), undefined);
                return;
              }
            },
            disabled: revoking,
            children: "Revoke invitation"
          })
        })
      ]
    });
  } else {
    return null;
  }
}

let make = SubuserPendingInvitations;

exports.Fragment = Fragment;
exports.RevokeMutation = RevokeMutation;
exports.make = make;
/* commitMutation Not a pure module */
